import { type Experience, type ExperienceMark, ExperienceMarkPhase } from './constants';
import { SWITCHER_RENDER_START_PERFORMANCE_MARK, EXPERIENCES_TO_MARKS } from './constants';

export function experienceTimingsOf(experience: Experience): {
	endMark: string;
	key: ExperienceMark;
	startMark: string;
}[] {
	return EXPERIENCES_TO_MARKS[experience].map(generateUFOTiming);
}

function generateUFOTiming(mark: ExperienceMark) {
	return {
		key: mark,
		startMark: generateUFOMarkName(mark, ExperienceMarkPhase.START),
		endMark: generateUFOMarkName(mark, ExperienceMarkPhase.END),
	};
}

export const generateUFOMarkName = (mark: ExperienceMark, phase: ExperienceMarkPhase) =>
	`${mark}_${phase}`;

export const setSwitcherRenderStartMark = (): void => {
	performance.mark(SWITCHER_RENDER_START_PERFORMANCE_MARK);
};

export const getSwitcherRenderStartMark = (): number => {
	const renderStartPerformanceMarks = performance.getEntriesByName
		? performance.getEntriesByName(SWITCHER_RENDER_START_PERFORMANCE_MARK)
		: [];
	return renderStartPerformanceMarks[renderStartPerformanceMarks.length - 1]?.startTime;
};
